import React from 'react';
import './BidTypeBrands.css';
import bidTypeLogo from '../../../assets/bidtypelogo.png';
import bidTypeImage from '../../../assets/bidtypebrands.jpg';

const BidTypeBrands = () => {
  return (
    <div className="Bid-Type-Brands-Container">
      <img src={bidTypeImage} alt="Bid Type Brands" className="Bid-Type-Brands-Image" />
      <a href="https://bidtype.com/bid-type/frontend/" target="_blank" rel="noopener noreferrer">
        <img src={bidTypeLogo} alt="Bid Type Logo" className="Bid-Type-Brands-Logo" />
      </a>
    </div>
  );
};

export default BidTypeBrands;
